import React from "react";

type DocumentLinkProps = React.AnchorHTMLAttributes<HTMLAnchorElement> & {
    href: string;
    prefetch?: boolean;
};

export default function DocumentLink({href, prefetch: _prefetch, ...rest}: DocumentLinkProps) {
    return <a href={href} {...rest} />;
}
